export const APP_NAME = "Municipalidad Distrital de La Libertad de Pallán";
